/** Keep long editable text in the document flow without changing its value. */
export function installDocumentTextareas(document:Document){
 const window=document.defaultView!;
 const native=window.CSS.supports('field-sizing','content');
 const prepared=new WeakSet<HTMLTextAreaElement>();
 const observed=new Set<HTMLTextAreaElement>();
 const widths=new WeakMap<HTMLTextAreaElement,number>();
 let frame=0,disposed=false;
 const pixels=(value:string)=>Number.parseFloat(value)||0;

 function expand(field:HTMLTextAreaElement){
  if(!field.getClientRects().length)return;
  if(!prepared.has(field)){
   // Preserve the original rows/minimum size, including larger specialist fields.
   const style=window.getComputedStyle(field);
   field.style.minHeight=`${Math.max(pixels(style.minHeight),pixels(style.height))}px`;
   field.style.height='auto';field.style.maxHeight='none';field.style.resize='none';
   if(native)field.style.setProperty('field-sizing','content');
   else {resize.observe(field);observed.add(field);}
   prepared.add(field);
  }
  if(!native){
   field.style.height='auto';
   const style=window.getComputedStyle(field);
   const adjustment=style.boxSizing==='border-box'
    ?pixels(style.borderTopWidth)+pixels(style.borderBottomWidth)
    :-pixels(style.paddingTop)-pixels(style.paddingBottom);
   field.style.height=`${field.scrollHeight+adjustment}px`;
  }
 }
 function scan(){frame=0;if(disposed)return;for(const field of observed)if(!field.isConnected){resize.unobserve(field);observed.delete(field);}document.querySelectorAll('textarea').forEach(expand);}
 function schedule(){if(!frame&&!disposed)frame=window.requestAnimationFrame(scan);}
 const resize=new ResizeObserver(entries=>{for(const entry of entries){const field=entry.target as HTMLTextAreaElement;if(widths.get(field)!==entry.contentRect.width){widths.set(field,entry.contentRect.width);schedule();}}});
 const mutations=new MutationObserver(schedule);
 // Value/defaultValue changes, conditional fields and disclosures are covered.
 // Ignore our own style writes, so sizing cannot trigger an observer loop.
 mutations.observe(document.body,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['hidden','class','open','rows']});
 function input(event:Event){if(event.target instanceof HTMLTextAreaElement)expand(event.target);}
 document.addEventListener('input',input);document.addEventListener('change',input);
 document.addEventListener('reset',schedule);window.addEventListener('resize',schedule);
 void document.fonts.ready.then(schedule);schedule();
 return()=>{disposed=true;window.cancelAnimationFrame(frame);mutations.disconnect();resize.disconnect();document.removeEventListener('input',input);document.removeEventListener('change',input);document.removeEventListener('reset',schedule);window.removeEventListener('resize',schedule);};
}
